


































import useReplies from "@/composables/v2.1/useReplies";
import i18n from "@/libs/i18n";
import { useChatsStore } from "@/store/useChatsStore";
import { useDownloadAttachmentsStore } from "@/store/useDownloadAttachmentsStore";
import { downloadFile, getFullPath } from "@/utils/assets";
import { isMobile } from "@/utils/mobile";
import { ChatEntry } from "@/views/modules/messaging-inbox/useChat";
import { Asset } from "@saysimple-platform/dtos";
import { defineComponent, PropType } from "@vue/composition-api";
import { BButton, BFormCheckbox, VBTooltip } from "bootstrap-vue";
import { storeToRefs } from "pinia";
import { useToast } from "vue-toastification/composition";

export default defineComponent({
    components: {
        BButton,
        BFormCheckbox,
    },
    directives: {
        "b-tooltip": VBTooltip,
    },
    props: {
        entry: {
            type: Object as PropType<ChatEntry>,
            required: true,
        },
    },
    setup() {
        const chatsStore = useChatsStore();
        const downloadAttachmentsStore = useDownloadAttachmentsStore();
        const { attachments, isSelected, downloadsLimit, hasReachedLimit } = storeToRefs(downloadAttachmentsStore);
        const { addReply } = useReplies();
        const toast = useToast();

        const localDownloadFile = (asset: Asset) => {
            downloadFile(asset).catch(() => toast.error(i18n.t("toast.read.error")));
        };

        return {
            hasReachedLimit,
            downloadsLimit,
            attachments,
            isSelected,
            chatsStore,
            addReply,
            localDownloadFile,
            getFullPath,
            isMobile,
        };
    },
});
